"use client";

import { create } from "zustand";

interface AidaSpacingOffsets {
  right: number;
  bottom: number;
}

interface AidaSpacingStore {
  offsets: AidaSpacingOffsets;
  setOffset: (side: keyof AidaSpacingOffsets, value: number) => void;
  clearOffset: (side: keyof AidaSpacingOffsets) => void;
  resetOffsets: () => void;
}

const DEFAULT_OFFSETS: AidaSpacingOffsets = {
  right: 16,
  bottom: 16,
};

export const useAidaSpacing = create<AidaSpacingStore>((set) => ({
  offsets: DEFAULT_OFFSETS,
  setOffset: (side, value) =>
    set((state) => ({
      offsets: {
        ...state.offsets,
        [side]: Math.max(value, 16), // Minimum 16px
      },
    })),
  clearOffset: (side) =>
    set((state) => ({
      offsets: {
        ...state.offsets,
        [side]: 16, // Reset to default 16px
      },
    })),
  resetOffsets: () => set({ offsets: DEFAULT_OFFSETS }),
}));

export const useAidaOffsets = () => useAidaSpacing((state) => state.offsets);
